export default __webpack_public_path__ + "static/media/outfit.21bf0843.PNG";